import { buildAwsJobLogUrl } from 'constants/report';

import * as React from 'react';

import { OpenInNew } from '@mui/icons-material';
import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';
import { useTranslation } from 'react-i18next';

interface Props {
  handleClose: () => void;
  report: reports.AllReportsQueryRow;
}

const ViewJobLogMenuItem: React.FC<Props> = ({ handleClose, report }) => {
  const { t } = useTranslation();

  return (
    <MenuItem
      onClick={handleClose}
      component="a"
      href={buildAwsJobLogUrl(report.jobId)}
      target="_blank"
      rel="noopener noreferrer"
    >
      <ListItemIcon>
        <OpenInNew fontSize="small" color="primary" />
      </ListItemIcon>
      <ListItemText primary={t('reportsQa.menu.viewJobLog')} />
    </MenuItem>
  );
};

export default ViewJobLogMenuItem;
